import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ScriptTemplate, EventConfig, CanvasContext } from '../../interfaces/event-script.models';
import { BuilderNode } from '../../interfaces/builder-screen.models';
import { ScriptTemplateLibraryService } from '../../services/script-template-library.service';

/**
 * Container do modo simples com template gallery, configurator e preview
 */
@Component({
  selector: 'app-simple-mode',
  templateUrl: './simple-mode.component.html',
  styleUrls: ['./simple-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SimpleModeComponent implements OnInit {
  @Input() componentNode: BuilderNode | null = null;
  @Input() canvasContext: CanvasContext | null = null;
  @Input() eventConfig: EventConfig | null = null;
  @Input() eventType: 'onChange' | 'onInit' = 'onChange';
  @Output() configCreated = new EventEmitter<EventConfig>();

  availableTemplates: ScriptTemplate[] = [];
  selectedTemplate: ScriptTemplate | null = null;
  templateConfig: Record<string, any> = {};
  generatedEventConfig: EventConfig | null = null;

  constructor(
    private templateLibrary: ScriptTemplateLibraryService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadApplicableTemplates();
  }

  /**
   * Carrega templates aplicáveis ao componente atual
   */
  private loadApplicableTemplates(): void {
    if (!this.componentNode || !this.canvasContext) {
      return;
    }

    this.availableTemplates = this.templateLibrary.getApplicableTemplates(
      this.componentNode.type,
      this.canvasContext
    );

    this.cdr.markForCheck();
  }

  /**
   * Quando um template é selecionado
   */
  onTemplateSelected(template: ScriptTemplate | null): void {
    this.selectedTemplate = template;
    this.templateConfig = {};
    this.generatedEventConfig = null;
    this.cdr.markForCheck();
  }

  /**
   * Quando a configuração do template muda
   */
  onConfigChanged(config: Record<string, any>): void {
    this.templateConfig = config;
    this.generateEventConfig();
    this.cdr.markForCheck();
  }

  /**
   * Gera EventConfig baseado no template e configuração
   */
  private generateEventConfig(): void {
    if (!this.selectedTemplate) {
      this.generatedEventConfig = null;
      return;
    }

    const eventConfig = this.templateLibrary.instantiateTemplate(
      this.selectedTemplate.id,
      this.templateConfig
    );

    if (eventConfig) {
      // Ajustar tipo de evento se necessário
      eventConfig.eventType = this.eventType;
      this.generatedEventConfig = eventConfig;
    }
  }

  /**
   * Salva o evento configurado
   */
  save(): void {
    if (this.generatedEventConfig) {
      this.configCreated.emit(this.generatedEventConfig);
    }
  }

  /**
   * Verifica se pode salvar
   */
  canSave(): boolean {
    return !!this.generatedEventConfig && 
           !!this.selectedTemplate &&
           Object.keys(this.templateConfig).length > 0;
  }
}



